import {
	Checkbox,
	FormItem,
	ValidationError
} from "client/Components";
import { UsersAndUserGroupsDataModel } from "client/Api/UserGroupsManagement/userGroupsManagement";
import { attachToUserAndUserGroupCollection } from "client/Features/Users/UserAndUserGroupCollection/attachable";
import {
	UserAndUserGroupCollection,
	UserAndUserGroupKind
} from "client/Features/Users/UserAndUserGroupCollection/UserAndUserGroupCollection";
import { ActiveTab } from "client/Features/Users/UserAndUserGroupTabSelector/UserAndUserGroupTabSelector";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { HubItemComposerDialog } from "../../HubItemComposerDialog/HubItemComposerDialog";
import { AnnouncementSaveModel, AnnouncementStatus } from "client/Api/Announcements/announcements";
import { IValueInputAttachable } from "client/Forms/attachable";

const {
	Title,
	Step,
	Content,
	FormContainer
} = HubItemComposerDialog;

export type RecipientsStepProps = {
	isActive: boolean;
	attachable: IValueInputAttachable<AnnouncementSaveModel>;
	status: AnnouncementStatus;
	usersAndUserGroupsData: UsersAndUserGroupsDataModel;
	infoAlerts?: ReactElement;
};

export const RecipientsStep = (props: RecipientsStepProps): ReactElement => {
	const {
		isActive,
		attachable,
		status,
		usersAndUserGroupsData,
		infoAlerts
	} = props;

	const isPlanned: boolean = status === AnnouncementStatus.Planned;
	const isDraft: boolean = status === AnnouncementStatus.Draft;

	const hasMultipleCategories: boolean = attachable.value
		.categoryIds
		.length > 1;

	return (
		<Step
			isActive={isActive}
			trackingId="recipients-step"
		>
			<Content stretchHeight>
				{infoAlerts}
				<FormContainer>
					<Title text={localize("_Recipients")} />
					<FormItem>
						<Checkbox
							{...attachable.for("isForEveryoneInTheCategories").attachToCheckbox()}
							text={
								localize(
									hasMultipleCategories
										? "_EveryoneWhoHasAccessToTheCategories"
										: "_EveryoneWhoHasAccessToTheCategory"
								)
							}
							isDisabled={!isPlanned && !isDraft}
						/>
						<ValidationError {...attachable.for("isForEveryoneInTheCategories").attachToValidationError()} />
					</FormItem>
				</FormContainer>
				<UserAndUserGroupCollection
					{...attachToUserAndUserGroupCollection(
						attachable.for("recipients"),
						!isPlanned && !isDraft
							? {
								kind: UserAndUserGroupKind.Read
							}
							: {
								kind: UserAndUserGroupKind.Edit,
								dialogTitleWhenAddingUsersAndUserGroups: localize("_AddRecipients")
							}
					)}
					activeTab={ActiveTab.UserGroup}
					allUsersAndUserGroupsData={usersAndUserGroupsData}
				/>
			</Content>
		</Step>
	);
};
RecipientsStep.displayName = "RecipientsStep";